import { render, staticRenderFns } from "./createLeadArticlesSearchTable.vue?vue&type=template&id=44624987&"
import script from "./createLeadArticlesSearchTable.vue?vue&type=script&lang=js&"
export * from "./createLeadArticlesSearchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports